module.exports = __webpack_public_path__ + "static/media/cbbanner2.663396a4.jpeg";